export const EMP_LIST="EMP_LIST";